document.addEventListener('DOMContentLoaded', () => {
  // ─── Helpers ───────────────────────────────────────────────
  const getMenu = () => document.querySelector('[data-dw-mobile-menu-overlay]');
  const openMenu = () => {
    const menu = getMenu();
    if (!menu) return;
    menu.showModal();
    document.documentElement.classList.add('dw-menu-is-open');
  };
  const closeMenu = () => {
    const menu = getMenu();
    if (!menu) return;
    menu.classList.add('is-closing');
    window.setTimeout(() => {
      menu.close();
      menu.classList.remove('is-closing');
      document.documentElement.classList.remove('dw-menu-is-open');
    }, 240);
  };
  // ─── Open / Close ──────────────────────────────────────────
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-dw-mobile-menu-open]')) openMenu();
    if (event.target.closest('[data-dw-mobile-menu-close]')) closeMenu();
    const menu = getMenu();
    if (menu && event.target === menu) closeMenu();
    // Close the menu when a nav link inside it is tapped
    if (menu && event.target.closest('.dw-mobile-menu__link')) closeMenu();
  });
  // Close on Escape (native <dialog> already does this, but also
  // makes sure our closing animation/class cleanup runs)
  document.addEventListener('keydown', (event) => {
    const menu = getMenu();
    if (event.key === 'Escape' && menu && menu.open) {
      event.preventDefault();
      closeMenu();
    }
  });
});